import PageLayout from "@/components/PageLayout";
import PageHeader from "@/components/PageHeader";
import { motion } from "framer-motion";
import SEO from "@/components/SEO";
import OpeningExceptionBanner from "@/components/OpeningExceptionBanner";

const jokelaHours = [
  { day: "Maanantai", time: "16:00–19:00" },
  { day: "Tiistai", time: "16:00–19:00" },
  { day: "Torstai", time: "16:00–19:00" },
  { day: "Perjantai", time: "9:00–12:00" },
];

const kellokoskiHours = [
  { day: "Maanantai", time: "16:00–19:00" },
  { day: "Tiistai", time: "16:00–19:00" },
  { day: "Keskiviikko", time: "16:15–19:00" },
  { day: "Torstai", time: "9:00–12:00" },
];

export default function AukiolotPage() {
  return (
    <PageLayout>
      <SEO title="Aukioloajat — Kuntosali Takomo" description="Kuntosali Takomon aukioloajat ja asiakaspalvelun päivystysajat. Jokela 24/7, Kellokoski 05–22. Tervetuloa tutustumiskäynnille!" path="/aukiolot" />
      <PageHeader title="Aukioloajat" subtitle="Tervetuloa tutustumiskäynnille päivystysaikoina 💪" />

      <section className="section-padding">
        <div className="container mx-auto max-w-4xl">
          <OpeningExceptionBanner />
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-card-premium rounded-lg p-8 mb-12 text-center"
          >
            <h2 className="font-display text-2xl font-bold text-foreground mb-2">Asiakkaille</h2>
            <p className="text-muted-foreground mb-6">Kulkukortilla pääset vuoden jokaisena päivänä</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-muted/30 rounded-lg p-6">
                <h3 className="font-display text-xl font-semibold text-foreground mb-1">Jokela</h3>
                <p className="text-primary font-display text-3xl font-bold">24/7</p>
              </div>
              <div className="bg-muted/30 rounded-lg p-6">
                <h3 className="font-display text-xl font-semibold text-foreground mb-1">Kellokoski</h3>
                <p className="text-primary font-display text-3xl font-bold">05–22</p>
              </div>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="bg-card-premium rounded-lg p-6">
              <h3 className="font-display text-xl font-semibold text-foreground mb-1">Jokela — Asiakaspalvelu</h3>
              <div className="divider-primary mb-4" />
              <div className="space-y-3">
                {jokelaHours.map((h) => (
                  <div key={h.day} className="flex justify-between text-sm">
                    <span className="text-foreground/80">{h.day}</span>
                    <span className="text-primary font-semibold">{h.time}</span>
                  </div>
                ))}
              </div>
            </motion.div>

            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }} className="bg-card-premium rounded-lg p-6">
              <h3 className="font-display text-xl font-semibold text-foreground mb-1">Kellokoski — Asiakaspalvelu</h3>
              <div className="divider-primary mb-4" />
              <div className="space-y-3">
                {kellokoskiHours.map((h) => (
                  <div key={h.day} className="flex justify-between text-sm">
                    <span className="text-foreground/80">{h.day}</span>
                    <span className="text-primary font-semibold">{h.time}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-muted-foreground text-sm text-center mt-8"
          >
            Olemme paljon paikalla aukioloaikojen ulkopuolella — voimme sopia myös muun ajan.
          </motion.p>
        </div>
      </section>
    </PageLayout>
  );
}
